/* ==========================================================
   Pro Ase Sports | assets/pa-header.js  (static, cached)
   Sticky state + logo shrink, desktop dropdowns (hover, tap,
   keyboard), mobile drawer accordions, search panel.
   ========================================================== */
(function () {
  'use strict';

  var header = document.getElementById('paHeader');
  if (!header) return;

  function $(id) { return document.getElementById(id); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ── Scroll lock shared by menu + search ── */
  var locks = 0;
  function lock()   { if (++locks === 1) document.documentElement.classList.add('pa-menu-lock'); }
  function unlock() { if (--locks <= 0) { locks = 0; document.documentElement.classList.remove('pa-menu-lock'); } }

  /* ── Scrolled state (logo shrink + shadow) ── */
  var ann = $('announcementBar');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var limit = (ann ? ann.offsetHeight : 0) + 8;
      header.classList.toggle('is-scrolled', window.scrollY > limit);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Desktop dropdowns ── */
  var ddItems = $$('.pa-menu__item--dd', header);
  var hoverable = window.matchMedia('(hover: hover)');
  var closeTimer = null;

  function closeAll(except) {
    ddItems.forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var a = li.querySelector('.pa-menu__link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  }
  function openItem(li) {
    clearTimeout(closeTimer);
    closeAll(li);
    li.classList.add('is-open');
    var a = li.querySelector('.pa-menu__link');
    if (a) a.setAttribute('aria-expanded', 'true');
  }

  ddItems.forEach(function (li) {
    var link = li.querySelector('.pa-menu__link');
    li.addEventListener('mouseenter', function () { if (hoverable.matches) openItem(li); });
    li.addEventListener('mouseleave', function () {
      if (!hoverable.matches) return;
      closeTimer = setTimeout(function () { closeAll(); }, 120);
    });
    /* Touch screens: first tap opens the panel, second tap follows the link */
    if (link) link.addEventListener('click', function (e) {
      if (hoverable.matches) return;
      if (!li.classList.contains('is-open')) { e.preventDefault(); openItem(li); }
    });
    /* Keyboard: arrow down opens + focuses first link */
    if (link) link.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openItem(li);
        var first = li.querySelector('.pa-dd a');
        if (first) first.focus();
      }
    });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) li.classList.remove('is-open');
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.pa-menu__item--dd')) closeAll();
  });

  /* ── Mobile drawer ── */
  var drawer  = $('mobileDrawer');
  var overlay = $('menuOverlay');
  var burger  = $('menuBtn');
  var dClose  = $('drawerClose');

  function openMenu() {
    if (!drawer || drawer.classList.contains('is-open')) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    if (burger) { burger.classList.add('is-open'); burger.setAttribute('aria-expanded', 'true'); }
    lock();
    setTimeout(function () { if (dClose) dClose.focus(); }, 50);
  }
  function closeMenu() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    if (burger) { burger.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
    unlock();
  }
  if (burger)  burger.addEventListener('click', function () { drawer && drawer.classList.contains('is-open') ? closeMenu() : openMenu(); });
  if (dClose)  dClose.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  if (drawer) drawer.addEventListener('click', function (e) {
    var t = e.target.closest('.pa-drawer__toggle');
    if (!t) return;
    var sub = document.getElementById(t.getAttribute('aria-controls'));
    var open = t.getAttribute('aria-expanded') === 'true';
    /* top level behaves like an accordion: close siblings */
    if (!open && !t.classList.contains('pa-drawer__toggle--sm')) {
      $$('.pa-drawer__list > .pa-drawer__item > .pa-drawer__row > .pa-drawer__toggle[aria-expanded="true"]', drawer).forEach(function (o) {
        o.setAttribute('aria-expanded', 'false');
        var s = document.getElementById(o.getAttribute('aria-controls'));
        if (s) s.hidden = true;
      });
    }
    t.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (sub) sub.hidden = open;
  });

  /* ── Search panel ── */
  var sModal = $('searchModal');
  var sToggle = $('searchToggle');
  var sClose = $('searchClose');
  var sInput = $('searchInput');

  function openSearch() {
    if (!sModal || sModal.classList.contains('is-open')) return;
    sModal.classList.add('is-open');
    sModal.setAttribute('aria-hidden', 'false');
    if (sToggle) sToggle.setAttribute('aria-expanded', 'true');
    lock();
    setTimeout(function () { if (sInput) sInput.focus(); }, 80);
  }
  function closeSearch() {
    if (!sModal || !sModal.classList.contains('is-open')) return;
    sModal.classList.remove('is-open');
    sModal.setAttribute('aria-hidden', 'true');
    if (sToggle) { sToggle.setAttribute('aria-expanded', 'false'); sToggle.focus(); }
    unlock();
  }
  if (sToggle) sToggle.addEventListener('click', openSearch);
  if (sClose)  sClose.addEventListener('click', closeSearch);
  if (sModal)  sModal.addEventListener('click', function (e) { if (e.target === sModal) closeSearch(); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) { closeMenu(); return; }
    if (sModal && sModal.classList.contains('is-open')) { closeSearch(); return; }
    closeAll();
  });

  /* Close the drawer if the screen grows to desktop */
  window.matchMedia('(min-width: 1200px)').addEventListener('change', function (m) { if (m.matches) closeMenu(); });

  window.openMenu = openMenu;
  window.closeMenu = closeMenu;
  window.openSearch = openSearch;
  window.closeSearch = closeSearch;
})();
